import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    /* TODO, quali sono i requisiti per la password richiesti? (lunghezza, caratteri, ecc)  */
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (matchingControl?.errors && !matchingControl.errors['matching']) {
      return null;
    }

    if (control?.value !== matchingControl?.value) {
      matchingControl?.setErrors({ matching: true });
      return { matching: true };
    } else {
      matchingControl?.setErrors(null);
      return null;
    }
  };
}
